import { createContext, ReactElement, useContext } from 'react';
import { CheckInProps } from './useCheckInDialog';

export type CheckInContextProps = CheckInProps;

export const CheckInContext = createContext<CheckInContextProps | null>(null);

export const useCheckIn = () => {
  const context = useContext(CheckInContext);
  if (!context) {
    throw new Error('useCheckIn must be used within a CheckInProvider');
  }
  return context;
};

export function CheckInProvider({
  children,
  ...props
}: CheckInContextProps & {
  children?: ReactElement;
}) {
  return (
    <CheckInContext.Provider value={{ ...props }}>
      {children}
    </CheckInContext.Provider>
  );
}
